import { render } from "./MemberRegistration.vue?vue&type=template&id=3c51e890&scoped=true"
import script from "./MemberRegistration.vue?vue&type=script&lang=js"
export * from "./MemberRegistration.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=3c51e890&scoped=true&lang=css&external"
import "./MemberRegistration.vue?vue&type=style&index=1&id=3c51e890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c51e890"]])

export default __exports__